// extracted by mini-css-extract-plugin
module.exports = {"weekProgress":"Progress_weekProgress_2zA-0","glowBlock":"Progress_glowBlock_2tw_V","glow":"Progress_glow_3A-JK"};